import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-text-wrapper6',
  templateUrl: './image-text-wrapper6.component.html',
  styleUrls: ['./image-text-wrapper6.component.scss']
})
export class ImageTextWrapper6Component implements OnInit {

  @Input() imageTextwrapper6Type:string;
  @Input() imageTextwrapper6aType:string;
  @Input() imageTextwrapper6bType:string;

  constructor() { }

  ngOnInit(): void {
  }

}
